import { useTheme } from '@mui/material/styles';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';

import { Stack } from 'common/components/material';
import { EllipsisText } from 'common/components/ellipsis-text/ellipsis-text.component';
import { titleCase } from 'common/utils/app.utils';
import { IStaticDataSearchSuggestion } from '../interfaces/static-data-search-suggestion.interface';
import { StaticDataAvatarComponent } from './static-data-avatar.component';

const StaticDataSearchOptionItem: React.FC<{
  staticData: IStaticDataSearchSuggestion;
  searchTerm?: string;
}> = ({ staticData, searchTerm = '' }) => {
  const { palette } = useTheme();
  const { completeName, name, type, photo } = staticData;

  const displayedType = titleCase(type);
  const hasParent = completeName !== name;
  let description = displayedType;

  if (hasParent) {
    const index = completeName.lastIndexOf(` - ${name}`);
    const parentCompleteName = completeName.slice(0, index);
    description += ` in ${parentCompleteName}`;
  }

  const matches = match(description, searchTerm, { insideWords: true });
  const parts = parse(description, matches);

  return (
    <Stack
      direction="row"
      display="flex"
      alignItems="center"
      spacing={1}
      data-analytics-tag="search_suggest_visit_page"
    >
      <StaticDataAvatarComponent size="small" src={photo} />
      <EllipsisText
        lineclamp={1}
        variant="body4"
        fontWeight={500}
        color={palette.LinkText.Default}
        maxWidth="75%"
        flexShrink={0}
        sx={{ wordBreak: 'break-all' }}
      >
        {name}
      </EllipsisText>
      <EllipsisText
        lineclamp={1}
        variant="body4"
        fontWeight={500}
        color={palette.StaticDataChip.TextDefault}
        title={description}
        sx={{ wordBreak: 'break-all' }}
      >
        {parts.map((part, index) => (
          <span
            key={index}
            style={{
              color: part.highlight ? palette.Text.Headline : palette.Text.SubHeadline,
              fontWeight: part.highlight ? 500 : 400,
            }}
          >
            {part.text}
          </span>
        ))}
      </EllipsisText>
    </Stack>
  );
};

export default StaticDataSearchOptionItem;
